const projectData = [
  {
    id: 1,
    project_name: "Reactbook",
    project_url: "https://reactboook-rt.netlify.app/",
    project_description: "Facebook Clone in Reactjs",
    project_tech: "Reactjs, Firebase, Material UI",
  },
  {
    id: 2,
    project_name: "Reactbnb",
    project_url: "https://reactbnb-rt.netlify.app/",
    project_description: "Airbnb Clone in Reactjs",
    project_tech: "Reactjs, Material UI",
  },
  {
    id: 3,
    project_name: "Covid Tracker",
    project_url: "https://covid-tracker-rt.netlify.app/",
    project_description:
      "Covid Tracker with worldwide live cases update, Country wise filtering option and map representation",
    project_tech: "Reactjs,Leaflet Maps, Covid19 API, Material UI",
  },
  {
    id: 4,
    project_name: "Codepen",
    project_url: "https://codepen-rt.netlify.app/",
    project_description: "Codepen Clone in Reactjs",
    project_tech: "Reactjs, Material UI",
  },
];

export default projectData;
